export default __webpack_public_path__ + "static/media/guide.92243758.png";